import {  useContext, useEffect,useState } from 'react';
import React from 'react';

import TemplateItem from './dashboard.templateItem.component';
import AuthContext from "../../context/userAuth.context";
import CharacterContext from '../../context/CharacterContext';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useRadioGroup } from '@mui/material';
const PopularTemplates = ({ setpopupload, popupload, setCurrentchoose, ShowTemp, setShowTemp }) => {
    const { authenticationData } = useContext(AuthContext);
    const { TempData, setTempData } = useContext(CharacterContext);
    const [popTemplate, setpopTemplate] = useState(null);
    useEffect(() => {
        
        let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
        axios.get(authenticationData.ApiBaseURL + "/api/Template/GetRecentUsedTemplates", {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
            },
        }).then((response) => {
            if (response.data) {
                setpopTemplate({
                    popularTemplates: response.data.popularTemplates,
                    recentUsedTemplates: response.data.recentTemplates,
                })
                // setTempData({
                //     popularTemplates: response.data.popularTemplates,
                //     recentUsedTemplates: response.data.recentTemplates,
                // })
            }
        }).catch((error) => {
            
        });
    }, [])

    return (
        <div>
            <div className="row mb-3">
                <div className="col-12">
                    <h5 className="d-inline-block">Popular and Trending Templates</h5>
                    {/* <a className="viewAll pointer" onClick={() => {
                        let obj = {
                            Recent: false,
                            AllRecent: false,
                            Popular: false,
                            AllPopular: true
                        }
                        setShowTemp(obj)
                    }}>View All</a> */}
                </div>
            </div>

            <div className="gridViewTemplates mt-2">

                {popTemplate && popTemplate.popularTemplates.map((value, index) => {
                    return <React.Fragment key={index}>
                        <TemplateItem key={index} isPremium={value.isPremium} start={setCurrentchoose} ProjectData={value} showpop={setpopupload} checkpop={popupload}
                            imgRatio="1.5" flexGrow="20" paddingRatio="50" imgSrc={value.previewImagePath} title={value.projectName} />
                    </React.Fragment>
                })}


                {/* <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/1.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/7.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/2.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/8.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/3.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/9.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/4.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/10.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/5.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/10.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/6.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/9.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="2" flexGrow="20" paddingRatio="50" imgSrc="images/dashPics/DashboardMain/11.jpg" title="Title Here" duration="00:26" />
                <TemplateItem showpop={setpopupload} checkpop={popupload} imgRatio="0.5625" flexGrow="5.625" paddingRatio="177.6" imgSrc="images/dashPics/DashboardMain/7.jpg" title="Title Here" duration="00:26" /> */}

            </div>
        </div>
    );
};


export default PopularTemplates;